import { anomalyTypeColors } from "@/colorLegends";
import { ANOMALY_KINDS } from "@/constants/anomalyTypes";
import { toRaw } from "vue";

const ANOMALY_MAP_PRIORITY = {
  [ANOMALY_KINDS.AXIAL_CRACK]: 1,
  [ANOMALY_KINDS.CIRCUMFERENTIAL_CRACK]: 1,
  [ANOMALY_KINDS.CLAMP]: 1,
  [ANOMALY_KINDS.CORROSION]: 1,
  [ANOMALY_KINDS.CORROSION_INSIDE]: 1,
  [ANOMALY_KINDS.CORROSION_OUTSIDE]: 1,
  [ANOMALY_KINDS.CORROSION_PRODUCT]: 1,
  [ANOMALY_KINDS.DAMAGED_CEMENT]: 1,
  [ANOMALY_KINDS.DAMAGED_COATING]: 1,
  [ANOMALY_KINDS.DAMAGED_LINER]: 1,
  [ANOMALY_KINDS.DAMAGED_WALL_INSIDE]: 1,
  [ANOMALY_KINDS.DAMAGED_WALL_OUTSIDE]: 1,
  [ANOMALY_KINDS.SCALING]: 1,
  [ANOMALY_KINDS.DENT]: 1,
  [ANOMALY_KINDS.H2S]: 1,
  [ANOMALY_KINDS.POSSIBLE_LEAKAGE]: 1,
  [ANOMALY_KINDS.RADIAL_CRACK]: 1,
  [ANOMALY_KINDS.UNKNOWN_ANOMALY]: 1,
  [ANOMALY_KINDS.WIRE_BREAK]: 1,
  [ANOMALY_KINDS.DELAMINATION]: 1,
};

export function getAnomaliesMapData(
  anomalies,
  anomaliesTypes,
  checkedAnomaliesSelector,
  isWideMode
) {
  const prioritizedAnomalies = toRaw(anomalies).sort((a, b) => {
    const priorityA = ANOMALY_MAP_PRIORITY[a.anomaly_type] || 0;
    const priorityB = ANOMALY_MAP_PRIORITY[b.anomaly_type] || 0;

    return priorityA - priorityB;
  });
  const largeAnomalies = prioritizedAnomalies.filter(
    (anomaly) => anomaly.length >= 4
  );
  const smallAnomalies = prioritizedAnomalies.filter(
    (anomaly) => anomaly.length < 4
  );

  const largeAnomalyName = `anomalies_large`;

  const largeAnomaliesMapData = {
    id: largeAnomalyName,
    type: "linestring",
    sourceOptions: {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: largeAnomalies.map(({ id, geom, anomaly_type }) => ({
          type: "Feature",
          properties: {
            id,
            isDigupSelected: checkedAnomaliesSelector?.has(id),
            color: anomalyTypeColors[anomaly_type],
          },
          geometry: geom,
        })),
      },
    },
    layerOptions: {
      id: `layer_${largeAnomalyName}`,
      source: largeAnomalyName,
      layout: {
        visibility: "visible",
      },
      type: "line",
      paint: {
        "line-color": [
          "case",
          ["==", ["get", "isDigupSelected"], true],
          "#fc388d",
          ["get", "color"],
        ],
        "line-width": isWideMode
          ? 20
          : ["case", ["==", ["get", "isDigupSelected"], true], 11, 8],
        "line-opacity": 0.8,
      },
    },
  };

  const smallAnomalyName = `anomalies_small`;

  const smallAnomaliesMapData = {
    id: smallAnomalyName,
    type: "points",
    sourceOptions: {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: smallAnomalies.map(({ id, geom, anomaly_type }) => ({
          type: "Feature",
          properties: {
            id,
            isDigupSelected: checkedAnomaliesSelector?.has(id),
            color: anomalyTypeColors[anomaly_type],
          },
          geometry: {
            type: "Point",
            coordinates: geom.coordinates[0],
          },
        })),
      },
    },
    layerOptions: {
      id: `layer_${smallAnomalyName}`,
      source: smallAnomalyName,
      layout: {
        visibility: "visible",
      },
      type: "circle",
      paint: {
        "circle-color": [
          "case",
          ["==", ["get", "isDigupSelected"], true],
          "#fc388d",
          ["get", "color"],
        ],
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          10,
          2,
          22,
          ["case", ["==", ["get", "isDigupSelected"], true], 16, 14],
        ],
        "circle-opacity": 0.8,
      },
    },
  };

  return { largeAnomaliesMapData, smallAnomaliesMapData };
}
